<template>
  <f7-page class="page-panel-left">
    <f7-page-content class="dark-bg">
      <f7-block class="mt-1 mb-1">
        <p class="text-align-center" v-if="!_.isEmpty(user_info)">
          <img src="../assets/kos.logo.white.png" alt="Logo" style="width: 60%;"/>
        </p>
        <p class="text-align-center" v-else>
          <img src="../assets/logo.png" alt="Logo" style="width: 60%;"/>
        </p>
        <p class="text-align-center" v-if="!_.isEmpty(user_info)">
          Hi, <strong>{{ user_info.fullname }}</strong> <br/>
          <span v-if="user_info.review_status === 1">Credit : <strong>{{ user_info.system_credit }}</strong> |
        USDT : <strong>{{ user_info.wallet_balance | numeral('0,0[.]00') }}</strong></span>
        </p>
      </f7-block>
      <f7-list inset class="bg-transparent">
        <f7-list-item no-chevron link="/dashboard" title="Trang chính" panel-close v-if="!_.isEmpty(user_info)">
          <f7-icon slot="media" f7="house"></f7-icon>
        </f7-list-item>
        <f7-list-item no-chevron link="/" title="Quản lý Máy đào" panel-close v-else>
          <f7-icon slot="media" f7="house"></f7-icon>
        </f7-list-item>
        <f7-list-item no-chevron link panel-close href="#!" @click="toggleDarkMode" :title="$store.state.dark_mode ? 'Chế độ Ban ngày' : 'Chế độ Ban đêm'">
          <f7-icon slot="media" :f7="$store.state.dark_mode ? 'lightbulb' : 'lightbulb_fill'"></f7-icon>
        </f7-list-item>
        <f7-list-item no-chevron v-if="!_.isEmpty(user_info) && user_info.review_status === 1" link external panel-close href="reset://" title="Cập nhật Ứng dụng">
          <f7-icon slot="media" f7="arrow_counterclockwise"></f7-icon>
        </f7-list-item>
        <f7-list-item no-chevron v-if="!_.isEmpty(user_info)" link="#" @click.prevent="logout" title="Thoát" panel-close>
          <f7-icon slot="media" f7="square_arrow_left"></f7-icon>
        </f7-list-item>
      </f7-list>
      <template v-if="!_.isEmpty(user_info)">
        <f7-block-title class="text-color-white">HỖ TRỢ 24/7</f7-block-title>
        <f7-list inset class="mb-3 bg-transparent">
          <template v-if="(!_.isEmpty(user_info) && !_.isEmpty(user_info.mentor_info) && !_.isEmpty(user_info.mentor_info.telegram_username) && _.isNaN(parseFloat(user_info.mentor_info.telegram_username))) && user_info.review_status === 1">
            <f7-list-item no-chevron :link="`https://t.me/${user_info.mentor_info.telegram_username}`" title="Đại lý" external target="_blank" panel-close>
              <f7-icon slot="media" class="telegram" f7="paperplane_fill"></f7-icon>
            </f7-list-item>
          </template>
          <f7-list-item no-chevron link="https://alwaysopeninsafari.com/cskh-kts" external target="_blank" title="CSKH" panel-close>
            <f7-icon slot="media" class="telegram" f7="paperplane_fill"></f7-icon>
          </f7-list-item>
          <f7-list-item no-chevron link="/livechat" title="LiveChat" panel-close>
            <f7-icon slot="media" f7="bubble_left_bubble_right"></f7-icon>
          </f7-list-item>
        </f7-list>
      </template>
      <f7-block class="text-align-center mt-0">KTS &copy; v{{ $store.state.app_version }}</f7-block>
    </f7-page-content>
  </f7-page>
</template>
<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['user_info', 'exchange'])
  },
  data() {
    return {
      navigator: {
        userAgent: "Init"
      },
      intervalExchange: null
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$f7.views.main.router.navigate('/');
    },
    navigateMentorGenrateOrNot() {
      if (this._.isEmpty(this.user_info) || this._.isEmpty(this.user_info.telegram)) {
        this.$f7.panel.close();
        this.$f7.views.main.router.navigate('/tao-ma-gioi-thieu');
      }
      else{
        this.$copyText(this.user_info.username);
        this.showToastBottom('Đã copy');
      }
    },
    showToastBottom(text) {
      const self = this;
      if (!self.toastBottom) {
        self.toastBottom = self.$f7.toast.create({
          text: text,
          closeTimeout: 2000,
          position: 'bottom',
          horizontalPosition: 'center'
        });
      }
      self.toastBottom.open();
    },
    getExchangePrice() {
      this.$store.dispatch('getExchangePrice').then((data) => {
        this.$store.commit('UPDATE_EXCHANGE', data);
      });
    },
    toggleDarkMode() {
      this.$store.dispatch('toggleDarkMode');
    }
  },
  mounted() {
    this.navigator = navigator;
    // this.getExchangePrice();
    // this.intervalExchange = setInterval(this.getExchangePrice, 30000);
  },
  destroyed() {
    // clearInterval(this.intervalExchange);
  }
};
</script>
<style scoped>
.icon-color-dark-red i.icon {
  color : #C21923
}
i.icon.telegram {
  color : #25A4E2;
}
</style>
